import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import { IconSvg } from 'components/atoms';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  button: {
    color: '#ffffff',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    textAlign: 'left',
    fontSize: 16,
  },
  buttonSelected: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: theme.spacing(1 / 2),
  },
  buttonLabel: {
    lineHeight: '20px',
  },
  icon: {
    fontSize: `${theme.spacing(5)}px !important`,
  },
}));

const FilterButton = props => {
  const {
    className,
    icon,
    iconProps,
    value,
    title,
    onClick,
    selected,
    ...rest
  } = props;
  const classes = useStyles();

  const handleClick = event => {
    event.target.value = value;

    if (onClick) onClick(event);
  };

  return (
    <div
      className={clsx(classes.root, className, {
        [classes.buttonSelected]: selected,
      })}
    >
      <Button
        value={value}
        variant="text"
        size="large"
        className={clsx(classes.button)}
        classes={{
          label: classes.buttonLabel,
        }}
        onClick={handleClick}
        startIcon={
          <IconSvg
            name={icon}
            viewBox="0 0 1080 1080"
            fontSize="large"
            className={classes.icon}
            {...iconProps}
          />
        }
        {...rest}
      >
        {title || value}
      </Button>
    </div>
  );
};

FilterButton.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Text to show for filter
   */
  title: PropTypes.string,
  /**
   * Value to bind to event on click
   */
  value: PropTypes.any,
  /**
   * Apply css styling if selected
   */
  selected: PropTypes.bool,
};

export default FilterButton;
